module.exports = __webpack_public_path__ + "static/detoxifying-01-e625cf91b619eccde4a7e7883f80f1cc.jpg";